import { useQuery } from '@tanstack/react-query';
import { getContributorList, getContributorTable } from './query';
import { ContributorTableFilter, MetricFilterState } from '..';

export const QUERY_KEYS = {
  contributorList: 'contributorList',
  contributorTable: 'contributorTable',
};

export const useContriburotListGql = (
  filter: ContributorTableFilter,
  teamIds: string[],
  startDate: string,
  endDate: string,
  sprintId: string,
  contributors: string[],
  pageNumber: number,
  pageSize: number
) => {
  return useQuery(
    [
      QUERY_KEYS.contributorList,
      filter,
      teamIds,
      startDate,
      endDate,
      sprintId,
      contributors,
      pageNumber,
      pageSize,
    ],
    () =>
      getContributorList(
        filter,
        teamIds,
        startDate,
        endDate,
        sprintId,
        contributors,
        pageNumber,
        pageSize
      ),
    {
      select: (data) => data.ContributorsDataForTable,
      enabled: !!startDate && !!endDate,
    }
  );
};

export const useContributorTableGql = (
  filter: ContributorTableFilter,
  teamIds: string[],
  startDate: string,
  endDate: string,
  sprintId: string,
  metric: string,
  contributors: string[],
  filteredContributors: string[],
  pageNumber: number,
  pageSize: number,
  orderBy: string
) => {
  return useQuery(
    [
      QUERY_KEYS.contributorTable,
      filter,
      teamIds,
      startDate,
      endDate,
      sprintId,
      metric,
      contributors,
      pageNumber,
      pageSize,
      orderBy,
    ],
    () =>
      getContributorTable(
        filter,
        teamIds,
        startDate,
        endDate,
        sprintId,
        metric,
        contributors,
        filteredContributors,
        pageNumber,
        pageSize,
        orderBy
      ),
    {
      select: (data) => data.ContributorTable,
      enabled:
        !!startDate && !!endDate && (orderBy || filter.metricFilters.length > 0)
          ? true
          : contributors.length > 0,
    }
  );
};
